// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federberechnung/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federberechnungDE: PageEntry = {
  id: "post.federberechnung",
  locale: "de",
  slug: "federberechnung",
  seo: {
    title: "Glossar: Federberechnung einfach erklärt | Dietz GmbH",
    description: "Die Federberechnung bezieht sich auf den Prozess der mathematischen Analyse und Bestimmung der mechanischen Eigenschaften einer Feder. Ingenieure verwenden verschiedene Formeln und",
  },
  type: "post",
  h1: "Glossar: Federberechnung einfach erklärt",
  intro: "Die Federberechnung bezieht sich auf den Prozess der mathematischen Analyse und Bestimmung der mechanischen Eigenschaften einer Feder. Ingenieure verwenden verschiedene Formeln und Modelle, um Parameter wie Federkonstante, maximale Verformung, Belastung und freie Länge zu berechnen. Eine präzise Federberechnung ist entscheidend, um sicherzustellen, dass die Feder in einer bestimmten Anwendung optimal funktioniert. Dieser Prozess berücksichtigt die physikalischen Gesetze, Materialcharakteristika und die spezifischen Anforderungen des Systems, in dem die Feder eingesetzt wird.",
  blocks: [

  ],
};
